var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('LevalMenu',{attrs:{"LevalMenu":_vm.LevalMenu,"indexShow":_vm.IntroductData}}),_c('Introduct'),_c('Speed'),_c('Target'),_c('History')],1)}
var staticRenderFns = []

export { render, staticRenderFns }